module.exports = __webpack_public_path__ + "assets/img/Eimele-1-Landing-Page.11672bff.jpg";